import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  Input,
  notification,
  Upload,
  Select,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";

const { Option } = Select;
const { TextArea } = Input;

const CreateContent = (props) => {
  const { setDrawerVisibility, setRefetch, rowData } = props;
  const [fileList, setFileList] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [allEvents, setAllEvents] = useState(null);
  const [contentType, setContentType] = useState(0);

  useEffect(() => {
    fetch("/api/Event/GetAllEvents")
      .then((res) => res.json())
      .then((data) => {
        const activeEvents = data.filter((item) => item.isActive === true);
        setAllEvents(activeEvents);
      })
      .catch((err) => {
        console.log(err.response);
        notification.error({
          message: "Unable to fetch events",
          description: "",
        });
      });

    if (rowData) {
      setContentType(rowData.contentTypeId);
    }
  }, []);

  const handleContentCreate = (values) => {
    const { name, eventId, contentTypeId, file, location } = values;
    setBtnLoading(true);
    let formData = new FormData();
    formData.append("Name", name);
    formData.append("Location", contentTypeId !== 1 ? location : null);
    formData.append("EventId", eventId);
    formData.append("ContentTypeId", contentTypeId);
    formData.append("File", file && file.file && file.file.originFileObj);
    if (rowData) {
      formData.append("Id", rowData.id);
    }
    axios(
      rowData ? "/api/Content/UpdateContent" : "/api/Content/CreateContent",
      {
        method: "POST",
        data: formData,
      }
    )
      .then((response) => {
        setBtnLoading(false);
        notification["success"]({
          message: "Success",
          description: `Content ${rowData ? "Updated" : "Created"
            } Successfully!`,
        });
        setDrawerVisibility(false);
        setRefetch((prev) => !prev);
      })
      .catch((err) => {
        setBtnLoading(false);
        notification.error({
          message: "Error",
          description: "Unable to Create Content",
        });
        console.log(err);
      });
  };

  const handleChange = (info) => {
    let fileList = [...info.fileList];
    fileList = fileList.slice(-1);
    setFileList(fileList);
  };

  const uploadProps = {
    accept: "image/*",
    onChange: handleChange,
  };

  let initialValues = {
    name: rowData && rowData.name,
    eventId: rowData && rowData.eventId,
    contentTypeId:
      rowData && rowData.contentTypeId && rowData.contentTypeId.toString(),
    location: rowData && rowData.location,
  };

  return (
    <Form
      onFinish={handleContentCreate}
      requiredMark={false}
      initialValues={initialValues}
    >
      <Row gutter={[20, 20]}>
        <Col span={24}>
          <Form.Item
            rules={[{ required: true, message: "Please input a name!" }]}
            name="name"
            label="Name"
            labelCol={{ span: 24 }}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[20, 20]}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "Please select an event!" }]}
            name="eventId"
            label="Event"
            labelCol={{ span: 24 }}
          >
            <Select placeholder="Select an event">
              {allEvents &&
                allEvents.map((item, index) => (
                  <Option key={index} value={item.eventID}>
                    {item.name}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="contentTypeId"
            label="Content Type"
            labelCol={{ span: 24 }}
            rules={[{ required: true, message: "Please select content type!" }]}
          >
            <Select
              placeholder="Select a content type"
              onChange={(e) => setContentType(e)}
            >
              <Option value="1">Background</Option>
              <Option value="2">TYM</Option>
              <Option value="3">TYT</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[20, 20]}>
        <Col span={24}>
          {contentType == 1 ? (
            <Form.Item
              rules={[{ required: true, message: "Please upload a file" }]}
              name="file"
              label="File"
              labelCol={{ span: 24 }}
            >
              <Upload {...uploadProps} fileList={fileList}>
                <Button icon={<UploadOutlined />}>Click to Upload</Button>
              </Upload>
            </Form.Item>
          ) : (
            <Form.Item
              rules={[{ required: true, message: "Please input message!" }]}
              name="location"
              label="Message"
              labelCol={{ span: 24 }}
            >
              <TextArea rows={4} />
            </Form.Item>
          )}
        </Col>
      </Row>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={btnLoading}>
          {rowData ? "Save" : "Create"}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default CreateContent;
